module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/welcome_to_teams.470bbceed6385936015ba1931d5bbdde.svg";